import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import StatCounter from '../common/StatCounter';
import { FiBriefcase, FiCode, FiAward, FiBookOpen } from 'react-icons/fi';
import './StatsSection.css';

const stats = [
  { icon: FiBriefcase, end: 4, suffix: '+', label: 'Projects' },
  { icon: FiCode, end: 12, suffix: '+', label: 'Skills' },
  { icon: FiAward, end: 5, suffix: '+', label: 'Certifications' },
  { icon: FiBookOpen, end: 3, suffix: '+', label: 'Years Experience' },
];

const StatsSection = () => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section className="stats-section" ref={ref}>
      <div className="container">
        <div className={`stats-grid ${isVisible ? 'fade-in' : ''}`}>
          {stats.map((stat, i) => (
            <div key={i} className="stat-card glass">
              <stat.icon size={32} className="stat-icon" />
              <h3 className="stat-number">
                <StatCounter end={stat.end} suffix={stat.suffix} />
              </h3>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
